/* import __COLOCATED_TEMPLATE__ from './title-input.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class FinProfileTitleInput extends Component {
  @service contentEditorService;

  get ruleset() {
    return this.contentEditorService.ruleset;
  }

  get profile() {
    return this.contentEditorService.activeObject;
  }

  @action
  trimContentTitle() {
    this.ruleset.clientData.title = this.ruleset.clientData.title.trim();
    this.profile.title = this.profile.title.trim();
  }

  @action
  setTitle(newValue) {
    this.ruleset.clientData.title = newValue;
    this.profile.title = newValue;
  }
}
